export const ourSolutions = () => {
  const headerH = document.querySelector('.header').scrollHeight
  const solutionsSection = document.querySelector('.our-solutions');
  if (window.innerWidth >= 1000 && document.querySelector('.our-solutions')) {
    gsap.registerPlugin(ScrollTrigger);
    const nextSection = solutionsSection.nextElementSibling;

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: '.our-solutions',
        start: 'bottom bottom',
        end: "+=250%",
        scrub: 1,
        pin: true,
        pinSpacing: true,
        invalidateOnResize: true,
        anticipatePin: 1,
        refreshPriority: 1,
      },
      defaults: { duration: 3, ease: 'none' }
    });
    const rows = document.querySelectorAll(".our-solutions__item");
    const titles = document.querySelectorAll(".our-solutions__item-title");
    const list = document.querySelectorAll(".our-solutions__item-list");
    const texts = document.querySelectorAll(".our-solutions__text");
    console.log(rows)
    console.log(list)
    list[0].style.maxHeight = `${list[0].scrollHeight}px`;
    texts[0].style.maxHeight = `${texts[0].scrollHeight}px`;
    rows.forEach((panel, i) => {

      if (i === 0) {
        timeline.to(panel, { opacity: 1, duration: 1 });
      }
      if (i > 0) {
        timeline.to(titles[i],
          { color: 'white', borderBottomColor: 'white', duration: 10 });
        timeline.to(titles[i-1],
          { color: 'rgba(255, 255, 255, .4)', borderBottomColor: 'transparent', duration: 10}, '<');
        timeline.to(list[i-1],
          { maxHeight: '0px', duration: 10 }, '<');
        timeline.to(texts[i-1],
          { maxHeight: '0px', duration: 10 }, '<');
        timeline.to(panel,
          { marginBottom: '50px', duration: 10 }, '<');


        timeline.to(list[i],
          { maxHeight: `${list[i].scrollHeight}px`, duration: 10 });
        timeline.to(rows[i-1],
          { marginBottom: '0px', duration: 10 }, '<');
        timeline.to(document.querySelectorAll(`.our-solutions__image`)[i],
          { y: '0', duration: 10 }, '<');
        timeline.to(texts[i-1],
          { maxHeight: '0px', duration: 10 }, '<');
        timeline.to(texts[i],
          { maxHeight: `${texts[i].scrollHeight}px`, duration: 10 }, '<');

        timeline.to(panel, { opacity: 1, duration: 1} );

      }
      if (i === rows.length - 1) {
        timeline.to(panel, { opacity: 1, duration: 5 });
      }
    });

    if (nextSection) {
      ScrollTrigger.create({
        trigger: '.our-solutions',
        start: 'bottom bottom',
        end: "+=250%",
        // важливо: invalidateOnResize і refreshPriority як і в основному тригері
        invalidateOnResize: true,
        onEnter: () => nextSection.classList.add('is-stuck-bottom'),
        onLeave: () => nextSection.classList.remove('is-stuck-bottom'),
        onEnterBack: () => nextSection.classList.add('is-stuck-bottom'),
        onLeaveBack: () => nextSection.classList.remove('is-stuck-bottom'),
      });
    }




    function setVH() {
      document.documentElement.style.setProperty('--next-section-top', `${solutionsSection.scrollHeight}px`);
    }
    setVH();
    window.addEventListener('resize', setVH);
  }


}